import { messages } from '../../../../../../../messages';
export var LozengeActionErrorMessages = {
  noData: {
    descriptor: messages['status_change_permission_error']
  },
  unknown: {
    descriptor: messages['status_change_load_error']
  },
  updateFailed: {
    descriptor: messages['status_change_update_error']
  }
};